import {RecordVI} from "./record/vi";
import {OkrVI} from "./okr/vi";

export const PersonnelVI = {
    "hrm": "HRM",
    "personnel": "Nhân sự",
    "application": "Đơn từ",
    ...OkrVI,
    ...RecordVI,
}